/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import { getAppConfig } from '../api';
import { Config } from '../types/config';
import { Nullable } from '../utils/types';

type TConfig$State = Nullable<Config>;

const initialState: TConfig$State = null;

export const Config$ = createStore<TConfig$State>(initialState);

const { set } = createApi(Config$, {
  // @ts-ignore
  set: (state, { result }) => (result.result === undefined ? state : result.result),
});

export const configApi = {
  get: createEffect().use(getAppConfig),
};

sample({
  clock: configApi.get.done,
  target: set,
});
